'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* HELD — not cleared for publication, and not routed.
 * Nature House is at "Contacted" on the testimonial tracker: the outreach
 * has gone out and they have not come back yet. No written approval is on
 * record, so this lives under `_held/` (a Next.js private folder, excluded
 * from routing) exactly like the seven stories legal took down in #200.
 * Move the directory up one level in the same commit that lands approval.
 *
 * Sourced from the implementation tracker (v1, Jul 28 2026) and the HubSpot
 * company record. No stats row and no results table, for the same reason as
 * the Prets story: the pilot's only figure is a dated internal snapshot, and
 * a placeholder metric here would be an invented claim. Add the stats, the
 * table and the six-place number check from the customer-stories skill in
 * the commit that lands cleared figures. */
const NatuurhuisjeCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Nature House"
        title={t.customerStories['natuurhuisje_hero_title']}
        subtitle={t.customerStories['natuurhuisje_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-natuurhuisje.svg',
          logoAlt: 'Nature House',
          customerName: 'Nature House',
          company: t.customerStories['natuurhuisje_company_description'],
          industry: t.customerStories['natuurhuisje_industry'],
          websiteUrl: 'https://www.natuurhuisje.nl',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['natuurhuisje_location'],
            },
          ],
          keyResults: [
            t.customerStories['natuurhuisje_key_result_1'],
            t.customerStories['natuurhuisje_key_result_2'],
            t.customerStories['natuurhuisje_key_result_3'],
            t.customerStories['natuurhuisje_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['natuurhuisje_intro']}</p>

        <h2>{t.customerStories['natuurhuisje_challenge_title']}</h2>
        <p>{t.customerStories['natuurhuisje_challenge_p1']}</p>
        <p>{t.customerStories['natuurhuisje_challenge_p2']}</p>
        <p>{t.customerStories['natuurhuisje_challenge_p3']}</p>

        <h2>{t.customerStories['natuurhuisje_solution_title']}</h2>
        <p>{t.customerStories['natuurhuisje_solution_p1']}</p>
        <p>{t.customerStories['natuurhuisje_solution_p2']}</p>
        <p>{t.customerStories['natuurhuisje_solution_p3']}</p>
        <p>{t.customerStories['natuurhuisje_solution_p4']}</p>

        <h2>{t.customerStories['natuurhuisje_impact_title']}</h2>
        <p>{t.customerStories['natuurhuisje_impact_p1']}</p>
        <p>{t.customerStories['natuurhuisje_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default NatuurhuisjeCaseStudy;
